import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import Close from "@material-ui/icons/Close";
import "./ContainerLoginModal.css";
import { Facebook as FacebookIcon } from "@material-ui/icons";
import {
  auth, // Import the auth instance
  signInWithGoogle,
  signInWithFacebook,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  createUserProfileDocument,
} from "../../firebase/firebase.utils";
import { RecaptchaVerifier } from "firebase/auth"; // Import RecaptchaVerifier

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

const useStyles = makeStyles((theme) => ({
  closeStyle: {
    position: "absolute",
    right: "8px",
    top: "8px",
    cursor: "pointer",
  },
  windowStyle: {
    padding: "40px 32px 32px",
    width: "400px",
  },
  titleStyle: {
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "28px",
    textAlign: "center",
    color: "rgb(32, 38, 46)",
    marginBottom: "0",
  },
  conditionStyle: {
    fontSize: "12px",
    lineHeight: "18px",
  },
}));

const AuthFormModal = ({ handleClose }) => {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleToggleMode = () => {
    setIsLoginMode(!isLoginMode);
    setErrorMessage("");
    setSuccessMessage("");
    setEmail("");
    setPassword("");
  };

  // Initialize RecaptchaVerifier - requires a container element with id="recaptcha-container"
  // You also need to add your domain to the reCAPTCHA settings in the Firebase console.
  // For local testing with emulators, reCAPTCHA is often bypassed or handled differently.
  // Ensure Firebase Auth emulator is running for local testing.
  const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "invisible", // Use 'invisible' for a seamless user experience
          callback: (response) => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            // ...
          },
          "expired-callback": () => {
            // Response expired. Ask user to solve reCAPTCHA again.
            // ...
          },
        },
        auth
      ); // 'auth' is the Firebase Auth instance
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    try {
      if (isLoginMode) {
        await signInWithEmailAndPassword(auth, email, password); // Pass auth instance
        handleClose();
      } else {
        // For sign-up, reCAPTCHA verification might be required in production.
        // Ensure reCAPTCHA is set up in Firebase console and initialized here.
        // setupRecaptcha(); // Call setup if using visible reCAPTCHA or need explicit initialization
        // const appVerifier = window.recaptchaVerifier; // Get the verifier instance

        const { user } = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        ); // Pass auth instance // Firebase handles invisible reCAPTCHA automatically if configured

        await sendEmailVerification(user);
        await createUserProfileDocument(user);
        setSuccessMessage("Compte créé ! Vérifiez votre email pour confirmer.");
        setTimeout(() => {
          handleClose();
        }, 3000);
      }
    } catch (error) {
      console.error(error);
      let message = "Une erreur s'est produite. Veuillez réessayer.";
      if (error.code === "auth/email-already-in-use") {
        message = "Cet email est déjà utilisé.";
      } else if (error.code === "auth/weak-password") {
        message = "Le mot de passe est trop faible.";
      } else if (
        error.code === "auth/user-not-found" ||
        error.code === "auth/wrong-password"
      ) {
        message = "Email ou mot de passe incorrect.";
      } else if (error.message && error.message.includes("recaptcha")) {
        message =
          "Erreur de configuration reCAPTCHA. Veuillez vérifier les paramètres Firebase pour la vérification anti-spam.";
      }
      setErrorMessage(message);
    }
  };

  return (
    <div className="signup-modal">
      {/* Add a div for reCAPTCHA - can be invisible */}
      <div id="recaptcha-container"></div>
      <TextField
        className="input-signup"
        label="Adresse email"
        variant="outlined"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="email"
      />
      <TextField
        className="input-signup"
        label="Mot de passe"
        variant="outlined"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
      />
      {errorMessage && (
        <p
          className="error-message"
          style={{ color: "red", textAlign: "center" }}
        >
          {errorMessage}
        </p>
      )}
      {successMessage && (
        <p
          className="success-message"
          style={{ color: "green", textAlign: "center" }}
        >
          {successMessage}
        </p>
      )}
      <Box alignItems="center" display="flex" flexDirection="column">
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={handleSubmit}
        >
          {isLoginMode ? "Se connecter" : "S'inscrire"}
        </Button>
      </Box>
      <p className="forgotten-password">Mot de passe oublié ?</p>
      <p
        className="modal-footer-register"
        onClick={handleToggleMode}
        style={{ cursor: "pointer", textAlign: "center" }}
      >
        {isLoginMode
          ? "Pas encore de compte ? S'inscrire"
          : "Déjà un compte ? Se connecter"}
      </p>
    </div>
  );
};

const LoginModal = ({ isOpen, handleClose, fullScreen, classes }) => {
  const localClasses = useStyles();
  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      TransitionComponent={Transition}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      fullWidth={false}
    >
      <div className={localClasses.windowStyle} id="login-modal">
        <IconButton
          key="close"
          aria-label="Close"
          className={localClasses.closeStyle}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
        <DialogTitle
          disableTypography
          className={classes.modalHeader + " " + localClasses.titleStyle}
        >
          <Typography
            variant="h6"
            gutterBottom
            className={classes.modalTitle + " " + localClasses.titleStyle}
          >
            Se connecter pour obtenir un accès<br></br> instantané à des
            milliers <br></br>de questions
          </Typography>
        </DialogTitle>
        <DialogActions
          style={{ display: "flex", flexFlow: "column", padding: 4 }}
        >
          <div className={classes.socialLine}>
            <Typography
              gutterBottom
              className={classes.modalTitle + " " + localClasses.conditionStyle}
            >
              En continuant, vous acceptez nos Conditions d'utilisation et vous
              reconnaissez notre Politique de confidentialité.
            </Typography>
            <Button
              className="google gd-btn social-button"
              data-testid="googleBtn"
              onClick={signInWithGoogle}
            >
              <span className="SVGInline">
                <svg
                  className="SVGInline-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 46 46"
                >
                  <path
                    d="M23 8.9a12.75 12.75 0 018.9 3.4L38.37 6A22.1 22.1 0 0023 0 23 23 0 002.45 12.68l7.44 5.78A13.9 13.9 0 0123 8.9z"
                    fill="#ea4335"
                  ></path>
                  <path
                    d="M45.08 23.5a19.7 19.7 0 00-.5-4.7H23v8.55h12.68A11.24 11.24 0 0131 34.8l7.26 5.63c4.34-4 6.85-9.92 6.85-16.92z"
                    fill="#4285f4"
                  ></path>
                  <path
                    d="M9.92 27.55A14.16 14.16 0 019.15 23a14.88 14.88 0 01.74-4.55l-7.45-5.77a23 23 0 000 20.65l7.46-5.78z"
                    fill="#fbbc05"
                  ></path>
                  <path
                    d="M23 46a21.92 21.92 0 0015.23-5.57L31 34.8a13.6 13.6 0 01-8 2.3 13.85 13.85 0 01-13.08-9.55l-7.44 5.77A22.94 22.94 0 0023 46z"
                    fill="#34a853"
                  ></path>
                  <path d="M0 0h46v46H0V0z" fill="none"></path>
                </svg>
              </span>
              <span className="label">Continuer avec Google</span>
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="facebook-login-button"
              onClick={signInWithFacebook}
            >
              <FacebookIcon id="facebook-icon-login" />
              Continuer avec Facebook
            </Button>
          </div>

          <Box
            className="orSeparator"
            display="flex"
            flexGrow={1}
            alignItems="center"
          >
            <Box className="borderTop" width="100%"></Box>

            <div className="orText px-xsm strong">
              <span className="orText">ou</span>
            </div>
            <Box className="borderTop" width="100%"></Box>
          </Box>
          <AuthFormModal handleClose={handleClose} />
        </DialogActions>
      </div>
    </Dialog>
  );
};

LoginModal.defaultProps = {
  classes: {},
};

export default LoginModal;
